import { createContext, useContext, useState, ReactNode } from 'react';
import { FilterConfig } from '@/components/layout/SectionFilterBar';

interface SearchConfig {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
}

interface FilterConfigExtended {
  isOpen: boolean;
  onToggle: () => void;
  activeCount: number;
  filters: FilterConfig[];
  onClearFilters?: () => void;
}

interface SectionSearchContextType {
  searchConfig: SearchConfig | null;
  filterConfig: FilterConfigExtended | null;
  setSearchConfig: (config: SearchConfig | null) => void;
  setFilterConfig: (config: FilterConfigExtended | null) => void;
}

const SectionSearchContext = createContext<SectionSearchContextType | undefined>(undefined);

export function SectionSearchProvider({ children }: { children: ReactNode }) {
  const [searchConfig, setSearchConfig] = useState<SearchConfig | null>(null);
  const [filterConfig, setFilterConfig] = useState<FilterConfigExtended | null>(null);

  return (
    <SectionSearchContext.Provider
      value={{
        searchConfig,
        filterConfig,
        setSearchConfig,
        setFilterConfig,
      }}
    >
      {children}
    </SectionSearchContext.Provider>
  );
}

export function useSectionSearch() {
  const context = useContext(SectionSearchContext);
  if (!context) {
    throw new Error('useSectionSearch must be used within SectionSearchProvider');
  }
  return context;
}
